import(/* webpackMode: "eager" */ "/vercel/path0/web-app/src/app/r/[[...redirect-sub-route]]/page.tsx");
